/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Help_CenterInputs */

const en_search_help_center = /** @type {(inputs: Search_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search for answers or browse our knowledge base`)
};

const nl_search_help_center = /** @type {(inputs: Search_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoeken naar antwoorden of bladeren door onze kennisbank`)
};

/**
* | output |
* | --- |
* | "Search for answers or browse our knowledge base" |
*
* @param {Search_Help_CenterInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const search_help_center = /** @type {((inputs?: Search_Help_CenterInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Help_CenterInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_search_help_center(inputs)
	return en_search_help_center(inputs)
});